import { MenuIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'

interface SettingsLayoutMobileHeaderProps {
  contentTitle?: string
  contentDescription?: string
  onMenuOpen: () => void
}

export const SettingsLayoutMobileHeader = ({
  contentTitle,
  contentDescription,
  onMenuOpen,
}: SettingsLayoutMobileHeaderProps): ReactNode => (
  <header className="settings-layout-header shrink-0 border-b">
    <div className="flex items-center gap-3 p-4">
      <Button
        variant="ghost"
        size="icon"
        className="settings-menu-trigger shrink-0"
        onClick={onMenuOpen}
        aria-label="Open settings menu"
      >
        <MenuIcon className="size-5" />
      </Button>
      {contentTitle && (
        <div className="min-w-0">
          <h1 className="truncate text-lg font-semibold">{contentTitle}</h1>
          {contentDescription && (
            <p className="truncate text-sm text-muted-foreground">{contentDescription}</p>
          )}
        </div>
      )}
    </div>
  </header>
)
